import { PasswordChangeRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * sendPasswordResetByUserEmail - Function that updates the user password  
 * /authenticator/change-password   
 * method PUT 
 * @async-function
 */
const updatePasswordByUserId = async (token: string, model: PasswordChangeRequestType) => {
    const response = await api.put(
        `/authenticator/change-password`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updatePasswordByUserId;